import { FC } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { AnnualActivity } from '../../context/AnalyticsContext';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface AnalyticsGraphProps {
	title: string;
	data: AnnualActivity[];
	color: string;
}

const AnalyticsGraph: FC<AnalyticsGraphProps> = ({ title, data, color }) => {
	const sortedData = [...data].sort((a, b) => a.year - b.year);

	const labels = sortedData.map(entry => entry.year);
	const counts = title.toLowerCase().includes("citation")
		? sortedData.map(entry => entry.cited_by_count)
		: sortedData.map(entry => entry.works_count);

	const chartData = {
		labels,
		datasets: [
			{
				label: title,
				data: counts,
				backgroundColor: color,
				borderColor: color.replace("0.6", "1"),
				borderWidth: 1,
			},
		],
	};

	const options = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			y: {
				beginAtZero: true,
				title: {
					display: true,
					text: "Count",
				},
			},
			x: {
				title: {
					display: true,
					text: "Year"
				},
			},
		},
	}

	return (
		<div className="w-full h-[300px] px-4 sm:px-8 md:px-16 lg:px-24 py-4">
			<Bar data={chartData} options={options}/>
		</div>
	);
};

export default AnalyticsGraph;